import m from "../../geodata/es2015/congoLow";
window.am4geodata_congoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/congoLow.js
// module id = null
// module chunks = 